import platforms from "./platforms";

const inProd = process.env.NODE_ENV === "production";

const PLAN_OPTIONS = [
  "free", // Free tier, limited usage or features
  "pay_as_you_go", // Billed purely based on specific usage units (tokens, operations, time, etc.)
  "subscription_tiered", // Fixed monthly/yearly fee with included usage allowance and potentially overage charges
  "credit_based", // Purchase or receive credits that are consumed by usage
  "seat_based", // Billed per user/seat, common for developer tools like Copilot
  "custom_enterprise", // Tailored plans, often with negotiated rates and terms
];

const config = {
  inProd,
  PLAN_OPTIONS,
  apiPlatform: {
    proPlanRequired: true,
    creditsBasedBilling: true,
    baseApiURL: inProd
      ? "https://api.aicosts.ai"
      : "http://localhost:3000",
    minCreditsForAccess: 10, // Minimum credits needed for API access
  },
  cookies: {
    consentCookieLabel: "consent-cookie",
  },
  emails: {
    support: inProd ? process.env.REACT_APP_SUPPORT_EMAIL : "support@localhost",
    team: inProd ? process.env.REACT_APP_TEAM_EMAIL : "team@localhost",
  },
  links: {
    affiliateProgram:
      "mailto:team@aicosts.ai?subject=Referral Program Application&body=Hi, I'd like to join the referral program.%0D%0A%0D%0APlease find my details below:%0D%0A%0D%0AEmail: %0D%0ASocial Media Profiles: %0D%0A%0D%0AThank you!",
    baseWebURL: "https://aicosts.ai",
    baseAppURL: "https://app.aicosts.ai",
    baseAPIURL: inProd
      ? process.env.REACT_APP_API_URL
      : "http://localhost:4000",
    blog: "https://aicosts.ai/blog.html",
    legal: "/legal/terms",
    pricing: "https://aicosts.ai/#pricing",
    stripeCustomerPortalURL: inProd
      ? "https://billing.stripe.com/p/login/14k00he561TqeaIfYY"
      : "https://billing.stripe.com/p/login/test_aEU7sK9ST2Ki0Xm9AA",
  },
  platforms: {
    totalPlatforms: 6,
    asList: () => Object.values(platforms),
    asMap: () => platforms,
    getByKey: (key: string) => (platforms as any)[key],
  },
  turnstile: {
    siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || "siteKey",
  },
};

export default config;
